export const DEBUG = true;
export const FRAME_DELTA_LIMIT = 3;
export const FRAME_TIME = 16.666; // milliseconds